import { AttendanceType } from "@/api";
import { buildAbsenceTimes } from "@/common/components/appointments/plan-attendance/PlanAttendanceDialog.utils";

export function resolveTimesOnPurposeChange(
  newAttendanceType: AttendanceType | null,
  currentAttendanceType: AttendanceType | null,
  date: Date | null
): { startTime: Date; endTime: Date } | { startTime: null; endTime: null } | undefined {
  if (newAttendanceType === AttendanceType.Absent) {
    return buildAbsenceTimes(date ?? new Date(0));
  }
  if (currentAttendanceType === AttendanceType.Absent) {
    return { startTime: null, endTime: null };
  }
  return undefined;
}
